import React from 'react';
import { useTranslation } from 'react-i18next';
import PeopleSummary from '../PeopleSummary';

const I18N_BASE_PATH =
  'pages.private.KYBCompany.pages.companyDetails.subPages.people.businessIdentity';

const PeopleSummaryContent = ({ directors, shareholders, officers }) => {
  const { t: translate } = useTranslation();

  return (
    <PeopleSummary
      data={[
        {
          title: translate(`${I18N_BASE_PATH}.summary.columns.directors`, 'Directors'),
          content: directors?.length,
        },
        {
          title: translate(
            `${I18N_BASE_PATH}.summary.columns.shareholders`,
            'Shareholders'
          ),
          content: shareholders?.length,
        },
        {
          title: translate(`${I18N_BASE_PATH}.summary.columns.officers`, 'Officers'),
          content: officers?.length,
        },
      ]}
    />
  );
};

export default PeopleSummaryContent;
